// Portfolio Administration v1.0 — color-coded AccountState pill for the
// Loans list table. Mirrors the Vendors/Enforcers RegistryStatusPill shape
// but covers the 7 Loan account-state values from spec §13.

import { cn } from "@/design-system/lib/utils";

const STATE_CLASSES: Record<string, string> = {
  performing: "bg-status-success/20 text-status-success",
  "sub-performing": "bg-status-warning/20 text-status-warning",
  "non-performing": "bg-status-warning/30 text-onyx",
  defaulted: "bg-status-error/20 text-status-error",
  "charged-off": "bg-status-error/30 text-status-error",
  liquidated: "bg-gray-soft text-onyx",
  "paid-off": "bg-status-success/30 text-status-success",
};

export function LoanAccountStatePill({ state }: { state: string | null }) {
  const normalized = (state ?? "performing").toLowerCase();
  const klass = STATE_CLASSES[normalized] ?? "bg-gray-soft text-onyx";
  return (
    <span
      className={cn(
        "inline-flex items-center px-space-2 py-[2px] rounded-sm text-[10px] font-display font-bold uppercase tracking-[0.16em]",
        klass,
      )}
      data-testid={`loan-account-state-${normalized}`}
    >
      {normalized}
    </span>
  );
}
